<template>
  <div>
    <ad></ad>
    <div class="content">
      <inner-nav :innerData="navList[5]" :innerTitle="navList[5].navChildList[0].name" :innerLink="navList[5].navChildList[0].toLink"></inner-nav>
      <div class="idea-content">
        <!--<div class="idea-title">-->
        <!--<h1>旗下子公司</h1>-->
        <!--<h3>xxxxx</h3>-->
        <!--</div>-->
        <div class="idea-list">
          <ul>
             <li v-for="(item,index) in listConcepts" :key="index" class="idea-list-item">
               <img :src="item.imgUrl" alt="">
               <div class="idea-msg">
                 <div>{{item.englishTitle}}</div>
                 <div>
                   <h2>{{item.title}}</h2>
                   <p v-html="item.content">
                     {{item.content}}
                   </p>
                 </div>
                 <span></span>
               </div>
             </li>
          </ul>

        </div>


      </div>

    </div>
  </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  export default {
    name: "",
    data(){
      return {
        listConcepts:[]
      }
    },
    components: {
      ad,
      InnerNav
    },
    created(){
      this.$http.get(`/outer/concept/listConcepts.do`, {
        functionCode:1
      }).then((res)=>{
          this.listConcepts=res.data
      })
    }
  }
</script>

<style scoped lang="less">
  .idea-content{
    font-family:PingFangSC-Medium;
    padding-bottom: .6rem;
    padding-top:.3rem;
    width:12rem;
      .idea-title{
        padding-bottom:.3rem;
          h1{
            font-size:.24rem;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:.48rem;
          }
          h3{
            font-size:.14rem;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:.14rem;
          }
      }
      .idea-list-item{
        position: relative;
        height:6rem;
        width:12rem;
        margin-bottom:.3rem;
        clear:both;
        overflow:hidden;
          img{
            height:100%;
            width:9rem;
            float: left;
          }
          .idea-msg{
            position: absolute;
            top:.5rem;
            right:0;
            width:5.4rem;
            height:5rem;
            background: #fff;
            box-shadow:-20px 20px 20px 0px rgba(0,0,0,0.06);
            border:1px solid #eee;
            padding:.5rem .8rem;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
              >div:nth-child(1){
                font-size:.46rem;
                font-family:PingFangSC-Regular;
                font-weight:400;
                color:rgba(238,238,238,1);
                line-height:.40rem;
              }
              >div:nth-child(2){
                 width:calc(100% - 1.6rem);
                 position:absolute;
                 top:1.2rem;
                  h2{
                    font-size:.3rem;
                    font-weight:500;
                    color:rgba(51,51,51,1);
                    line-height:.30rem;
                  }
                  p{
                    font-size:.14rem;
                    font-weight:400;
                    color:#666;
                    line-height:.21rem;
                    margin-top:.3rem;
                    text-align: justify;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    display:-webkit-box;
                    -webkit-line-clamp:8;
                    -webkit-box-orient:vertical;
                    max-height: 1.68rem;
                  }
               }
              span{
                position: absolute;
                top:-1px;
                left:.8rem;
                width:.5rem;
                height:.1rem;
                background:#F53A37;
              }
          }
      }



  }
</style>




// WEBPACK FOOTER //
// src/pages/recruit/personnel-idea.vue